import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
// import Checkbox from "@material-ui/core/CheckBox";

import { Checkbox } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import AnimeList from "../ViewAllMentorList/AnimeList";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import viewAllMentorListButton from "../../../../../assets/svg/dashboard/viewAllMentorListButton.svg";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import "@fontsource/montserrat";
import requestMentor from "../../../../../assets/images/request-mentor.png";
import linewitdot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import dropdownicon from "../../../../../assets/images/arrow.png";
import mentorimage from "../../../../../assets/images/tm-3.jpg";
import orgimage from "../../../../../assets/images/platinum-mentor.png";
import Select from "react-select";
import CustomTooltip from "./tooltip";
import ComingSoon from "./comingSoonTooltip";
import { connect } from "react-redux";
import { State } from "country-state-city";
import useStyles from "./style";
import GlobalSelectComponent from "../../../../common/SelectComponent";
import { MENTOR_MATCH_LIST } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import { isLoading } from "../../../../common/dependencies/action/action";
import { useHistory, useParams } from "react-router-dom";
import Pagination from "react-js-pagination";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  PRODUCTION_MOVE_HIDDEN,
  SET_SELECTED_MENU,
} from "../../../../common/constants/actionConstants";
// #b499c7
// #3e4a59

import newBadge from "../../../../../assets/images/new-mentor.png";
import goldBadge from "../../../../../assets/images/gold-mentor.png";
import silveradge from "../../../../../assets/images/silver-mentor.png";
import platinumBadge from "../../../../../assets/images/platinum-mentor.png";
import { types } from "../../../../common/dependencies/reducer/comingSoonReducer";
import swal from "sweetalert";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const DisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box className={classes.lineWithDotContainer}>
        <img
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDot}
        />
      </Box>
      <Box
        style={{
          position: "absolute",
          height: "40px",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "#a495c6",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          width: "80% ",
        }}
      >
        {props.content}
      </Box>
    </Box>
  );
};

const UpperDisplaySurface = (props) => {
  const classes = useStyles();
  const { paginationData } = props;
  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container>
          <Grid item xs={12} md={2} className={classes.upperDisplayImage}>
            <img
              style={{ height: "100px" }}
              src={requestMentor}
              alt="peopleweblogo"
            />
          </Grid>
          <Grid item container spacing={1} xs={12} md={10}>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={[classes.headingthreeone, "headingthrough"]}
                style={{ whiteSpace: "nowrap" }}
              >
                MENTORS MATCHED
              </Typography>
              <Box className={classes.showInMiddle}>
                <DisplaySurface content={`${paginationData?.totalElements}`} />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography
                className={[classes.headingthreeone, "headingthrough"]}
              >
                REQUEST ID
              </Typography>
              <Box className={classes.showInMiddle}>
                <DisplaySurface
                  content={`${props.data?.id?.substr(
                    props.data?.id?.length - 6
                  )}`}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>
                INDUSTRY
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  {props.data?.requestJson?.industry}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>
                FUNCTION
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  {`${props.data?.requestJson?.function}`}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>STAGE</Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  {`${props.data?.requestJson?.stage}`}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography className={classes.headingthreeone}>
                KEYWORDS
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography
                  className={clsx(
                    classes.headingthreetwo,
                    classes.cursorPointer
                  )}
                  style={{ fontSize: "12px", textAlign: "left" }}
                >
                  <Tooltip
                    classes={{
                      tooltip: classes.root,
                      tooltipArrow: classes.tooltipArrow,
                    }}
                    title={
                      <div style={{ padding: "15px" }}>
                        {props.data?.requestJson?.keys?.sub_function &&
                          props.data?.requestJson?.keys?.sub_industry &&
                          [
                            ...props.data?.requestJson?.keys?.sub_function,
                            ...props.data?.requestJson?.keys?.sub_industry,
                          ].map((ele, index) => (
                            <Typography
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                color: "#fff",
                              }}
                            >
                              {index + 1}. {ele}
                            </Typography>
                          ))}
                      </div>
                    }
                    placement="left"
                    arrow
                  >
                    <div>
                      {props.data?.requestJson?.keys?.sub_function &&
                        props.data?.requestJson?.keys?.sub_industry &&
                        [
                          ...props.data?.requestJson?.keys?.sub_function,
                          ...props.data?.requestJson?.keys?.sub_industry,
                        ].map((ele, index) => {
                          return (
                            index < 4 && (
                              <>
                                {index + 1}. {ele}
                                <br />
                              </>
                            )
                          );
                        })}
                      {props.data?.requestJson?.keys?.sub_function &&
                        props.data?.requestJson?.keys?.sub_industry &&
                        [
                          ...props.data?.requestJson?.keys?.sub_function,
                          ...props.data?.requestJson?.keys?.sub_industry,
                        ].length > 4 &&
                        "..."}
                    </div>
                  </Tooltip>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const DisplayTextSurface = (props) => {
  const classes = useStyles();
  return (
    <>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box sx={{ fontSize: "35px", color: "#3AC2D7" }}>{props.content}</Box>
      </Box>
    </>
  );
};

const InnerCollapsibles = (props) => {
  const classes = useStyles();
  const { ele } = props;
  const [innerCollapsed, setInnerCollapsed] = useState(true);

  return (
    <Grid container alignItems="center" style={{ padding: "0 10px" }}>
      <Grid item xs={10}>
        <Box className={classes.flex}>
          <Typography
            style={{
              textAlign: "left",
              fontSize: "14px",
              fontFamily: "Montserrat",
              fontWeight: "bold",
              color: "#6f59a6",
              opacity: 0.9,
              flex: 1,
            }}
            className="homepageSecondDescription"
          >
            {ele.title} :
          </Typography>
          <IconButton
            size="small"
            onClick={() => setInnerCollapsed(!innerCollapsed)}
          >
            <ArrowForwardIosRoundedIcon
              style={{
                transform: innerCollapsed ? "rotate(90deg)" : "",
              }}
              fontSize="small"
            />
          </IconButton>
        </Box>
      </Grid>
      <Grid item xs={2} className="newuserTooltip">
        {ele.checked ? (
          <>
            <div>
              <Checkbox
                classes={{
                  root: classes.checkboxRoot,
                }}
                checked={ele.checked}
                disabled
              />
            </div>
            <span className="tooltiptext matched  tooltip-bottom2">
              Request Matched
            </span>
          </>
        ) : (
          <Checkbox
            classes={{
              root: classes.checkboxRoot,
            }}
            checked={ele.checked}
            disabled
          />
        )}
      </Grid>
      <Collapse in={innerCollapsed}>
        <Typography
          style={{
            textAlign: "left",
            fontSize: "14px",
            fontFamily: "Montserrat",
            fontWeight: "bold",
            color: "#3e4a59",
          }}
          className="homepageSecondDescription"
        >
          {ele?.tags?.map((tag, index) => (
            <React.Fragment key={index}>
              {index + 1}. {tag}
              <br />
            </React.Fragment>
          ))}
        </Typography>
      </Collapse>
    </Grid>
  );
};

const MentorCard = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };

  const { open, setOpen } = props;
  const classes = useStyles();
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(true);
  const { userRole, LoginData } = props;
  return (
    <Card elevation={3} className={classes.cardroot}>
      <CardContent className={classes.cardContent}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "0 13%",
            position: "relative",
          }}
        >
          {" "}
          {PRODUCTION_MOVE_HIDDEN && (
            <Box
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                height: "120px",
                width: "120px",
                backdropFilter: "blur(6px)",
              }}
            ></Box>
          )}
          <img
            src={props?.datum?.user?.uploadProfilePic || hashImage}
            className={classes.cardImage}
            style={{
              objectFit: props?.datum?.user?.uploadProfilePic
                ? "contain"
                : "cover",
            }}
            alt="mentor image"
          />
          {!PRODUCTION_MOVE_HIDDEN && props?.datum?.badge ? (
            <img
              style={{ marginLeft: "15px" }}
              src={
                props?.datum?.badge === "NEW"
                  ? newBadge
                  : props?.datum?.badge === "SILVER"
                  ? silveradge
                  : props?.datum?.badge === "GOLD"
                  ? goldBadge
                  : props?.datum?.badge === "PLATINUM"
                  ? platinumBadge
                  : ""
              }
              className={classes.cardImage}
              // alt="organization image"
            />
          ) : (
            ""
          )}
        </Box>
        <Typography
          className={clsx(classes.cardText1, "homepageFifthDescription")}
        >
          MENTOR MATCH
        </Typography>
        <DisplayTextSurface content={`${props?.datum?.total_percentage}%`} />
        <Typography
          className={clsx(classes.cardText2, "homepageFourthDescription")}
          style={{ position: "relative" }}
        >
          {PRODUCTION_MOVE_HIDDEN && (
            <Box
              style={{
                position: "absolute",
                left: "0",
                top: 0,
                height: "100%",
                width: "100%",
                backdropFilter: "blur(6px)",
              }}
            ></Box>
          )}
          {props?.datum?.user?.full_name}
        </Typography>
        <Divider style={{ backgroundColor: "#4cc4d6", height: "4px" }} />
        <Collapse in={collapsed}>
          <Grid container style={{ padding: "20px 10px" }}>
            {[
              {
                title: "Company",
                name: props.datum.user?.organization_name,
              },
              {
                title: "Designation",
                name: props.datum.user?.current_designation,
              },
              { title: "Country", name: props.datum.user?.country },
              { title: "State", name: props.datum.user?.state_name },
              { title: "City", name: props.datum.user?.city },
            ].map((item) => {
              return (
                <>
                  <Grid item xs={4}>
                    <Typography
                      className={clsx(
                        classes.informationTitle,
                        "homepageSecondDescription"
                      )}
                    >
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      className={clsx(
                        classes.informationTitle,
                        "homepageSecondDescription"
                      )}
                      style={{ transform: "translateX(10px)" }}
                    >
                      :
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      className={clsx(
                        classes.informationName,
                        "homepageSecondDescription"
                      )}
                    >
                      {item.name}
                    </Typography>
                  </Grid>
                </>
              );
            })}
          </Grid>
          <Divider />
          {[
            {
              title: "Industry",
              tags: props.datum?.user?.industry,
              checked: props.datum?._industry_match,
            },
            {
              title: "Sector/Industry Keywords",
              tags: props.datum?.user?.subindustry,
              checked: props.datum?._sub_industry_match,
            },
            {
              title: "Function",
              tags: props.datum?.user?.specialization,
              checked: props.datum?._function_match,
            },
            {
              title: "Function Keywords",
              tags: props.datum?.user?.subspecialization,
              checked: props.datum?._sub_function_match,
            },
            {
              title: "Stage",
              tags: props.datum?.user?.preferredStage,
              checked: props.datum?._stage_match,
            },
          ].map((ele, index) => {
            return <InnerCollapsibles ele={ele} />;
          })}
        </Collapse>
        <Box
          style={{
            width: "100%",
            borderRadius: "5px",
            border: "2px solid #3ac2d7",
            margin: "15px 0",
            paddingBottom: "20px",
          }}
        >
          <Typography className={classes.cardText3}>
            CURRENTLY MENTORING STARTUPS
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Box className={classes.circularDisplay}>
              {props?.datum?.active_mentorships}
            </Box>
          </Box>
        </Box>
        <div className="newuserTooltip">
          {!PRODUCTION_MOVE_HIDDEN && (
            <Button
              variant="contained"
              style={{
                textTransform: "none",
                padding: "5px 25px",
                borderRadius: "20px",
                backgroundColor: "#b499c7",
                color: "#fff",
                fontSize: "18px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                marginTop: "25px",
              }}
              className={classes.viewProfileButton}
              onClick={() => {
                const currentRoute = window.location.href;
                let sample;
                sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
                // let reRoute = window.open(
                //   `/mentor-profile/${props?.datum?.user?.email_id}`,
                //   "_blank"
                // );
                let reRoute = window.open(`/mentor-profile/${encryptAES2(props?.datum?.user?.email_id,PROFILE_KEY)}`, "_blank");
                reRoute.id = props?.datum?.user?.email_id;
                // if (props?.datum?.user?._id) {
                //   history.push({
                //     pathname: `mentor-profile/${props?.datum?.user?.email_id}`,
                //     state: {
                //       prevPage: "myRequests",
                //     },
                //   });
                // }
              }}
            >
              View Profile
            </Button>
          )}
          <span className="tooltiptext matchlistprofile tooltip-bottom">
            View Profile
          </span>
        </div>
        {props?.datum?.requestStatus ? (
          <Box style={{ width: "100%" }}>
            <CustomTooltip
              isPurpose={true}
              purpose={
                props?.datum?.purposeOfMentorship ||
                "This is the dummy purpose of mentorship"
              }
            >
              <Button
                disableRipple
                disableFocusRipple
                disableTouchRipple
                variant="contained"
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "18px",
                  textTransform: "none",
                  padding: "5px 25px",
                  fontWeight: 600,
                  marginTop: "20px",
                  borderRadius: "20px",
                  width: "70%",
                }}
              >
                {props?.datum?.requestStatus === "Requested"
                  ? "Request Sent"
                  : props?.datum?.requestStatus === "Declined"
                  ? "Request Declined"
                  : props?.datum?.requestStatus}
              </Button>
            </CustomTooltip>
          </Box>
        ) : (
          LoginData.role !== "Admin" &&
          (PRODUCTION_MOVE_HIDDEN ? (
            <div
              className="dashboard-purple-btn top-btn"
              style={{
                width: "100%",
                marginTop: "10px",
              }}
              onClick={() => props.setOpen(true)}
            >
              <span
                className="blue-link-dashboard"
                style={{
                  paddingRight: "0px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                Send Request
              </span>
            </div>
          ) : (
            <CustomTooltip
              mentorId={props?.datum?.user?._id}
              mentorMatchlistId={props.mentorMatchlistId}
              setDidDataChange={props.setDidDataChange}
              didDataChange={props.didDataChange}
            >
              <div
                className="dashboard-purple-btn top-btn sendrequest-00"
                style={{
                  marginTop: "10px",
                }}
              >
                <span
                  className="blue-link-dashboard "
                  style={{
                    paddingRight: "0px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "18px",
                    top: "3px",
                  }}
                >
                  Send Request
                </span>
              </div>
            </CustomTooltip>
          ))
        )}
        <Box style={{ marginTop: "10px" }}>
          <IconButton
            onClick={() => {
              if (collapsed) {
                setCollapsed(false);
              } else {
                setCollapsed(true);
              }
            }}
          >
            <img
              style={
                collapsed
                  ? { transform: "rotate(180deg)" }
                  : { transform: "none" }
              }
              src={dropdownicon}
            />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

const MentorMatchList = (props) => {
  const { getStepperTooltipData, getStepperData } = props;
  const html = document.getElementsByTagName("html")[0];
  const classes = useStyles();
  const history = useHistory();
  const [uncollapsedCard, setUncollapsedCard] = useState(null);
  const [data, setData] = useState();
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [didDataChange, setDidDataChange] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterIndustryKeyword, setFilterIndustryKeyword] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterFunctionKeyword, setFilterFunctionKeyword] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [open, setOpen] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const params = useParams();
  const value = localStorage.getItem("SavedLoggedInData");
  const LoginData = JSON.parse(value);

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => index !== 0);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  const addNewItem = (arr, label) => {
    arr?.unshift({ value: "", label: label });
    return arr;
  };

  const states = State.getStatesOfCountry("IN").map((item) => ({
    value: item.name,
    label: item.name,
  }));

  React.useEffect(() => {
    html.style.overflow = "auto";
    props.getPredefineOptionsList();
    if (PRODUCTION_MOVE_HIDDEN) {
      swal(
        "",
        `Dear Startup,

      Thank you for registering on MAARG. We will soon reveal your mentor match. For now, please feel free to explore the portal features and prepare your questions for the mentor! 
      
      We appreciate your patience.
      
      Warm regards,
      Startup India team`,
        "info"
      );
    }
  }, []);

  // props.openLoader();
  React.useEffect(() => {
    // axios({
    //   url: MENTOR_MATCH_LIST,
    //   method: "POST",
    //   data: {
    //     id: params.searchId,
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 9,
    //       sortField: "total_percentage",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(MENTOR_MATCH_LIST, {
        id: params.searchId,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 9,
          sortField: "total_percentage",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res?.data?.data);
        setPaginationData(res?.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  // React.useEffect(() => {
  // },[])
  React.useEffect(() => {
    setTimeout(() => {
      props.openLoader();
      // axios({
      //   url: MENTOR_MATCH_LIST,
      //   method: "POST",
      //   data: {
      //     id: params.searchId,
      //     pageFilter: {
      //       currentPage: currentPage - 1,
      //       includeCount: true,
      //       pageSize: 9,
      //       sortField: "total_percentage",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_MATCH_LIST, {
          id: params.searchId,
          pageFilter: {
            currentPage: currentPage - 1,
            includeCount: true,
            pageSize: 9,
            sortField: "total_percentage",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          setData(res?.data?.data);
          setPaginationData(res?.data?.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    }, 2000);
  }, [didDataChange]);

  React.useEffect(() => {
    props.openLoader();
    // axios({
    //   url: MENTOR_MATCH_LIST,
    //   method: "POST",
    //   data: {
    //     id: params.searchId,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 9,
    //       sortField: "total_percentage",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(MENTOR_MATCH_LIST, {
        id: params.searchId,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "total_percentage",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res?.data?.data);
        setPaginationData(res?.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, [currentPage]);

  const handleClickOfFilter = () => {
    // props.openLoader();
    let data = {};
    if (filterFunction.value) {
      data.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      data.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      data.stage = filterStage.value;
    }
    if (filterFunctionKeyword.value) {
      data.sub_function = [filterFunctionKeyword.value];
    }
    if (filterIndustryKeyword.value) {
      data.sub_industry = [filterIndustryKeyword.value];
    }
    if (filterState.value) {
      data.state = filterState.value;
    }
    // axios({
    //   url: MENTOR_MATCH_LIST,
    //   method: "POST",
    //   data: {
    //     // id: props.mentorMatchlistId,
    //     id: params.searchId,
    //     ...data,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 9,
    //       sortField: "total_percentage",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(MENTOR_MATCH_LIST, {
        // id: props.mentorMatchlistId,
        id: params.searchId,
        ...data,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "total_percentage",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res?.data?.data);
        setPaginationData(res?.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box
      style={{
        minHeight: "500px",
        paddingTop: "30px",
        paddingBottom: "30px",
        paddingTop: "100px",
      }}
    >
      <div className="iconWith-heading mentorshipreqiconwith">
        <div style={{ width: "100%" }}>
          <Typography
            className={clsx(classes.headingOne, "homepageSecondHeader")}
          >
            MAARG Portal by Startup India
          </Typography>
          <Typography
            className={clsx(classes.headingTwo, "homepageFirstHeader")}
          >
            MENTOR MATCHLIST
          </Typography>
        </div>
        {!PRODUCTION_MOVE_HIDDEN && (
          <div
            className="tooltipshow eyeIcon"
            onClick={() => {
              html.style.overflow = "hidden";
            }}
            style={{ paddingTop: "50px" }}
          >
            <div className="newuserTooltip">
              <img
                className="iconbtn top-btn"
                src={iconTooltip}
                onClick={setModalIsOpenToTrue}
                width={60}
              />{" "}
              <span
                className="tooltiptext tooltip-bottom "
                style={{ width: "130px", top: "50px", left: "20px" }}
              >
                View Instructions
              </span>
            </div>
          </div>
        )}
        {isShown && (
          <div>
            <AnimeList
              setModalIsOpenToTrue={setModalIsOpenToTrue}
              Heading={Heading}
              InstructionswithRole={InstructionswithRole}
              SelectPage={SelectPage}
            />
          </div>
        )}
      </div>
      <UpperDisplaySurface data={data} paginationData={paginationData} />
      {/* {data?.matchlist?.length>0? */}
      {/* <Typography className={classes.headingOne}> */}
      <Box className={classes.filterContainer}>
        <Typography className={classes.filterBy}>Filter By :</Typography>
        <Grid container spacing={1} alignItems="center">
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              options={removeFirstItem(
                props.selectOptions?.industry_options,
                "Select Industry"
              )}
              placeholder="Industry"
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustry(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "55px", width: "130px" }}
            >
              Search Industry
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Keywords"
              options={removeFirstItem(
                props.selectOptions?.sub_industry,
                "Select Industry Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustryKeyword(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Industry Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Function"
              options={removeFirstItem(
                props.selectOptions?._specialisation,
                "Select Function"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterFunction(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search Function
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Keywords"
              onChange={(selected) => setFilterFunctionKeyword(selected)}
              options={removeFirstItem(
                props.selectOptions?.functional_areas,
                "Select Function Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Function Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Stage"
              options={removeFirstItem(
                props.selectOptions?.stage_of_startup_options,
                "Select Stage"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    minWidth: "100%",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterStage(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search Stage
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="State"
              options={addNewItem(states, "Select State")}
              onChange={(selected) => setFilterState(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    transform: "translateX(-100px)",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search State
            </span>
          </Grid>
        </Grid>
        <div className="newuserTooltip top-btn gobtnmentorshipreq">
          <Button
            style={{
              marginLeft: "10px",
              fontFamily: "Montserrat",
              color: "#fff",
              fontSize: "16px",
              backgroundColor: "#3AC2D7",
            }}
            variant="contained"
            // className={classes.goButton}
            onClick={handleClickOfFilter}
          >
            GO
          </Button>
          <span className="tooltiptext filter  tooltip-bottom">
            Click to Apply Filters
          </span>
        </div>
      </Box>
      {/* :"" */}
      {/* } */}
      <Typography
        style={{
          textAlign: "right",
          marginTop: "10px",
          marginBottom: "20px",
          padding: "0  7%",
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.5)",
          fontWeight: "bold",
        }}
      >
        {data?.matchlist?.length > 0
          ? `Total Matches Found: ${paginationData?.totalElements} < ${paginationData?.currentPage} of ${paginationData?.numPages} >`
          : ""}
      </Typography>
      <Typography
        style={{
          textAlign: "center",
          marginBottom: "40px",
          padding: "0  7%",
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.5)",
          fontWeight: "bold",
          fontSize: "18px",
          color: "#6f59a6",
        }}
        className="homepageFifthDescription"
      >
        {data && data?.matchlist?.length > 0
          ? "Note: You Can Send upto 3 Mentor Requests"
          : data?.matchlist?.length == 0
          ? " No Match Found "
          : "Please Wait, Loading .... "}
      </Typography>

      <Box
        sx={{
          padding: "0 7% 0 7%",
        }}
      >
        <Grid alignItem="dense" container spacing={4}>
          {data?.matchlist?.map((datum, index) => (
            <Grid item xs={12} md={6} lg={4}>
              <MentorCard
                open={props.open}
                setOpen={props.setOpen}
                setUncollapsedCard={setUncollapsedCard}
                uncollapsedCard={uncollapsedCard}
                currentIndex={index}
                datum={datum}
                mentorMatchlistId={data.id}
                setDidDataChange={setDidDataChange}
                didDataChange={didDataChange}
                userRole={LoginData.role}
                LoginData={LoginData}
              />
            </Grid>
          ))}
        </Grid>
        {data?.matchlist?.length > 0 ? (
          <div className="pagination-box" style={{ marginTop: "20px" }}>
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={9}
              totalItemsCount={paginationData?.totalElements}
              pageRangeDisplayed={5}
              onChange={handleChangeOfPage.bind(this)}
            />
          </div>
        ) : (
          ""
        )}
      </Box>
      {LoginData?.role !== "Admin" ? (
        <Box
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            background:
              "linear-gradient(0deg, rgba(247,243,255,1) 0%, rgba(217,199,230,0.9082983535210959) 100%)",
            padding: "50px 0",
            marginTop: "30px",
          }}
        >
          {!PRODUCTION_MOVE_HIDDEN ? (
            <div className="newuserTooltip">
              <img
                className={clsx("top-btn", classes.sendRequestButton)}
                src={viewAllMentorListButton}
                onClick={() => {
                  if (PRODUCTION_MOVE_HIDDEN) {
                    props.setOpen();
                    return;
                  }
                  window.open("/startup-dashboard/all-mentor-list", "_blank");
                }}
              />
              <span className="tooltiptext mentorList  tooltip-bottom">
                View All Mentors List
              </span>
            </div>
          ) : (
            ""
          )}
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  getStepperData: state.AdminMentorReducer.getStepperList.list,
  open: state.comingSoon.open,
});

// const mapDispatchToProps = (dispatch) => ({
//   openLoader: () => dispatch(isLoading(true)),
//   closeLoader: () => dispatch(isLoading(false)),
//   getPredefineOptionsList
// });

const setSelectedMenu = (payload) => (dispatch) => {
  dispatch({ type: SET_SELECTED_MENU, payload });
};

const setOpen = () => (dispatch) => {
  dispatch({ type: types.SET_OPEN });
};
const setClose = () => (dispatch) => {
  dispatch({ type: types.SET_CLOSE });
};

export default connect(mapStateToProps, {
  openLoader,
  closeLoader,
  getPredefineOptionsList,
  setSelectedMenu,
  setOpen,
  setClose,
  getStepperTooltipData,
})(MentorMatchList);
